import { Component } from '@angular/core';

@Component({
  selector: 'app-crea-esrs',
  standalone: false,

  templateUrl: './crea-esrs.component.html',
  styleUrl: './crea-esrs.component.scss',
})
export class CreaEsrsComponent {}
